import { createAPI } from '@common'

export default {
  // 获取人员信息
  getUsersWithPage: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0vtfsdbu0vtfstXjuiQbhf', 'get', config),
  // 移除人员
  postUsersRemove: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0vtfsdbu0sfnpwf', 'POST', config),
  // 设置人员
  postUsersRel: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0vtfsdbu0sfm', 'POST', config)
}
